import React, { useRef, useState} from 'react';
import moment from 'moment';
import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';
import { AdminUserSettingsHeaderLink } from "../../components/adminSettingsHeaderLinks/AdminUserSettingsHeaderLink.jsx";
import './TrolleySetup.css'
import { Toast } from "primereact/toast";
import { getTrolleyPayrollRequest } from "../../services/wisdomServices/reportService";
import WisdomDropdown from "../../components/dropdown/WisdomDropdown.jsx";
import { payFrequencies } from "../../utils/helper/payFrequencies";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import WisdomDataTable from "../../components/dataTable/WisdomDataTable.jsx";
import { exportCSV } from '../../utils/helper/exports';
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Can } from '../../security/Can.jsx';
import { PERMISSIONS } from '../../security/permissions.generated.js';

/**
 * @function TrolleySetup
 * @returns {JSX.Element} - trolley setup page
 */
function TrolleySetup () {
    const toast = useRef(null)
    let [selectedFrequency, setSelectedFrequency] = useState(null);
    let [payrollData,setPayrollData] = useState([]);
    let [loading,setLoading] = useState(false);
    const [from, setFrom] = useState(null)
    const [to, setTo] = useState(null)
    const [filters, setFilters] = useState({
        global: {value:null, matchMode: FilterMatchMode.CONTAINS},
        'Reference ID': {value:null, matchMode: FilterMatchMode.CONTAINS}
    })
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const globalFilters = ['Reference ID']

    const handleExportCsv = () => {
        exportCSV(payrollData, 'Trolley_report')
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const trolleyAmountCurrency = (rowData) => {
        return formatCurrency(rowData.Amount);
    };

    const columns = [
        {
          field: 'Reference ID',
          header: 'Reference ID'
        },
        {
            header: 'Amount',
            body: trolleyAmountCurrency
        },
    ]

    const header = (
        <div className='trolley-report-table-header'>
            <div>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
            </div>
            <Button label='Export csv' type="button" icon="pi pi-file-excel" rounded onClick={handleExportCsv} severity="success" data-pr-tooltip="XLS" title='Export csv file'/>
        </div>
    )
  
    /**
     * @async
     * @function getPayrollDetails
     * @description - fetches payroll data and formats it into a Trolley-compatible structure
     */
    const getPayrollDetails = async () => {
        setLoading(true)

        if (from == null || to == null) {
            setLoading(false)
            return
        }

        try {
            const response = await getTrolleyPayrollRequest(
                moment(from).format("YYYY-MM-DD"),
                moment(to).format("YYYY-MM-DD"),
                selectedFrequency,
            )

            const items = response.data


            const formatted = items.map(item => {
                const monthYear = moment(to).format('MM/YYYY')

                return {
                    "Email": ' ',
                    "Reference ID": item.username,
                    "Recipient ID": ' ',
                    "Amount": Math.round(item.totalAmount),
                    "Currency": ' ',
                    "Cover Fees": 'No',
                    "Taxable": 'No',
                    "Payment Reason": ' ',
                    "US Tax Activity": ' ',
                    "Memo": item.additionalPayments > 0
                        ? `Sirius payment for month: ${monthYear} + Additional Payment: ${item.additionalPayments}`
                        : `Sirius payment for month: ${monthYear}`,
                    "Tags": item.payFrequency,
                    "External Id": ' '
                }
            })

            setPayrollData(formatted)

        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    return(
        <div className="settingsContainer">
            <AdminUserSettingsHeaderLink/>
            <Toast ref={toast} position="top-center"/>
            {  
                <Box sx={{ flexGrow: 1 }} className="settingsBody">
                    <Grid container spacing={2}>
                        <Grid size={10}>
                            <h3 className="settingsLabel">Trolley Report</h3>

                        </Grid>
                        <Grid size={10}>
                            <div className="trolley-page-header-form">
                                <WisdomDropdown 
                                    placeholder="Select a frequency"
                                    value={selectedFrequency}
                                    onChange={(e) => setSelectedFrequency(e.value)}
                                    highlightOnSelect={false}
                                    checkmark={true}
                                    options={payFrequencies}
                                    optionalLabel="label"
                                    optionalValue="value"
                                />
                                <div>
                                    <FloatLabel>
                                        <Calendar 
                                            inputId="trolley-setup-from-date-picker"
                                            value={from}
                                            onChange={(e) => setFrom(e.value)}
                                            maxDate={new Date()}
                                            disabled={selectedFrequency === ''}
                                            dateFormat="dd/mm/yy"
                                        
                                        />
                                        <label htmlFor="trolley-setup-from-date-picker">From date</label>
                                    </FloatLabel>
                                </div>
                                <div>
                                    <FloatLabel>
                                        <Calendar 
                                            inputId="trolley-setup-to-date-picker"
                                            value={to}
                                            onChange={(e) => setTo(e.value)}
                                            minDate={from}
                                            maxDate={new Date()}
                                            disabled={from == null}
                                            dateFormat="dd/mm/yy"
                                        />
                                        <label htmlFor="trolley-setup-to-date-picker" >To date</label>
                                    </FloatLabel>
                                </div>
                                <Can permission={PERMISSIONS.reportsPayroll_get}>
                                    <Button 
                                        label="Generate" 
                                        severity="info"
                                        onClick={getPayrollDetails}
                                        disabled={selectedFrequency === '' || from === null || to === null}
                                    />
                                </Can>
                            </div>
                        </Grid>
                        <Grid size={10}>
                        <div className='project-details-card'>
                            <div id='section-project-members'>
                                <DataTable 
                                    value={payrollData} 
                                    columns={columns} 
                                    header={header} 
                                    loading={loading} 
                                    filters={filters} 
                                    globalFilterFields={globalFilters}
                                    paginator
                                    rows={25}
                                >
                                    {columns.map((column, i) => {
                                        return(
                                            <Column 
                                                key={column.field}
                                                field={column.field} 
                                                header={column.header} 
                                                body={column?.body}
                                                bodyStyle={column?.bodyStyle}
                                                headerStyle={column?.headerStyle}
                                            />
                                        )
                                    })}
                                </DataTable>
                            </div>
                        </div>
                        </Grid>
                    </Grid>
                </Box>
            }
        </div>
    );
}

export default TrolleySetup;